export default {
    state: {
        navTree: [],  // 导航菜单树
        menuPower:[], //菜单权限
    },
    getters: {
   
    },
    mutations: {
        setNavTree(state, navTree){  // 设置导航菜单树
            state.navTree = navTree;
        },
        setMenuPower(state, menuPower){  // 菜单权限为了控制浏览器直接输入地址控制权限
            state.menuPower = menuPower;
        }
    },
    actions: {
        
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/menu.js